import { observable, action } from 'mobx';
import { Helper } from '../../../Helper';

export class TeamsStore {

  @observable public title: string;

  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public token: string;
  @observable public language: "Danish" | "English" | "Swedish" | "German" | "Portuguese" | "Norwegian";

  @observable public numCards: number;
  @observable public containerWidth: number;
  @observable public cardWidth: number;
  @observable public borderColor: string;

  @observable public posts: any[];

  // Language

  @action public setLanguage(language: "Danish" | "English" | "Swedish" | "German" | "Portuguese" | "Norwegian") {
    this.language = language;
    Helper.setLocalStorage("IA_language", language);
  }

}